import { User } from '../types/AuthTypes';

export const getUserInitials = (user: User | null): string | null => {
  if (!user) return null;

  const firstName = user.firstName || '';
  const lastName = user.lastName || '';

  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  return initials || null;
};

export const hasUserRole = (user: User | null, role: string): boolean => {
  if (!user || !user.role) return false;

  return Array.isArray(user.role)
    ? user.role.includes(role)
    : user.role === role;
};
